<template>
  <div class="stats-chart-helper">
    <!-- eslint-disable-next-line -->
    <i18n v-if="isDoubleChart" path="APP.STATS_BUILDER.DOUBLE_HELPER_TEXT">
      <span place="primary_name">
        {{ primaryChart.title }}
        <ElTooltip
          v-if="primaryChart.description"
          :content="primaryChart.description"
          placement="top-start"
        >
          <small>
            <i class="el-icon-question stats-chart-helper__desc-icon" />
          </small>
        </ElTooltip>
      </span>
      <span place="secondary_name">
        {{ secondaryChart.title }}
        <ElTooltip
          v-if="secondaryChart.description"
          :content="secondaryChart.description"
          placement="top-start"
        >
          <small>
            <i class="el-icon-question stats-chart-helper__desc-icon" />
          </small>
        </ElTooltip>
      </span>
    </i18n>
    <!-- eslint-disable-next-line -->
    <i18n
      v-else-if="hasTag"
      path="APP.STATS_BUILDER.SINGLE_WITH_TAG_HELPER_TEXT"
    >
      <span place="primary_name">
        {{ primaryChart.title }}
        <ElTooltip
          v-if="primaryChart.description"
          :content="primaryChart.description"
          placement="top-start"
        >
          <small>
            <i class="el-icon-question stats-chart-helper__desc-icon" />
          </small>
        </ElTooltip>
      </span>
      <span place="tag_name">
        {{ tagChart.title }}
        <ElTooltip
          v-if="secondaryChart.description"
          :content="secondaryChart.description"
          placement="top-start"
        >
          <small>
            <i class="el-icon-question stats-chart-helper__desc-icon" />
          </small>
        </ElTooltip>
      </span>
    </i18n>
    <!-- eslint-disable-next-line -->
    <i18n v-else path="APP.STATS_BUILDER.SINGLE_HELPER_TEXT">
      <span place="primary_name">
        {{ primaryChart.title }}
        <ElTooltip
          v-if="primaryChart.description"
          :content="primaryChart.description"
        >
          <small>
            <i class="el-icon-question stats-chart-helper__desc-icon" />
          </small>
        </ElTooltip>
      </span>
    </i18n>
    <StatsAnnouncement
      v-if="shouldShowStatsAnnouncement"
      :title="announcement.title"
      :text="announcement.text"
      class="stats-chart-helper__announcement-button"
    />
  </div>
</template>

<script>
import { APP_CHARTS_CONFIG } from '@/store/types';
import StatsAnnouncement from '../StatsAnnouncement';
import { mapGetters } from 'vuex';

export default {
  name: 'StatsChartHelper',
  components: {
    StatsAnnouncement,
  },
  props: {
    primaryType: {
      type: Object,
      required: true,
    },
    secondaryType: {
      type: Object,
      default: () => ({}),
    },
    announcement: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      chartsConfig: APP_CHARTS_CONFIG,
    }),

    isDoubleChart() {
      return this.primaryType.type && this.secondaryType.type;
    },
    hasTag() {
      return this.primaryType.tag && Boolean(this.tagChart.title);
    },

    primaryChart() {
      const { child } = this.primaryType;
      const chart = this.chartsConfig[child];
      return {
        title: chart && chart.title,
        description: chart && chart.description,
      };
    },

    secondaryChart() {
      const { child } = this.secondaryType;
      const chart = this.chartsConfig[child];
      return {
        title: chart && chart.title,
        description: chart && chart.description,
      };
    },

    tagChart() {
      const { tag } = this.primaryType;
      const chart = this.chartsConfig[tag];
      return {
        title: chart && chart.title,
        description: chart && chart.description,
      };
    },
    shouldShowStatsAnnouncement() {
      return Boolean(this.announcement.title);
    },
  },
};
</script>

<style lang="scss">
.stats-chart-helper {
  display: flex;
  justify-content: center;
  align-items: center;
  @include breakpoint(small down) {
    flex-direction: column;
  }

  &__desc-icon {
    position: relative;
    top: -6px;
  }

  &__announcement-button {
    margin-left: $global-margin;
    @include rtl() {
      margin-left: 0;
      margin-right: $global-margin;
    }

    @include breakpoint(small down) {
      margin: $global-margin 0 !important;
    }
  }
}
</style>
